import { Component, OnInit, Input } from '@angular/core';
//import * as moment from 'moment-timezone';

@Component({
  selector: 'app-analog-clock',
  templateUrl: './analog-clock.component.html',
  styleUrls: ['./analog-clock.component.scss']
})
export class AnalogClockComponent implements OnInit {
  @Input() isShowSecond = true;

  hourRotation = 0;
  minuteRotation = 0;
  secondRotation = 0;

  constructor() {
    let d = this.getZoneBasedDate();
    this.calculateRotations(d);
  }

  ngOnInit(): void {
    setInterval(() => {
      let d = this.getZoneBasedDate();
      this.calculateRotations(d);
    }, 1000);
  }

  private getZoneBasedDate() {
    //return new Date(moment.tz(moment.tz.guess()).format());
    return new Date();
  }

  private calculateRotations(d: Date) {
    let hour = d.getHours();
    let minute = d.getMinutes();
    let second = d.getSeconds();

    this.hourRotation = 30 * hour + minute / 2;
    this.minuteRotation = 6 * minute;
    this.secondRotation = 6 * second;
  }
}
